// removed by extract-text-webpack-plugin
module.exports = {"fieldSection":"fieldSection__2-esM","itempropKey":"itempropKey__1vvdv","itempropValue":"itempropValue__1ZoLt","fieldTitle":"fieldTitle__WBavj","dateMeta":"dateMeta___xHbc","schoolName":"schoolName__18TxZ","metaPanelCard":"metaPanelCard__9lQYZ","metaPanelCardBody":"metaPanelCardBody__2Jypd"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/account/program/style.scss
// module id = 321
// module chunks = 0